import { RESET_POINT_OF_SALE_STATE } from '@dynameat/views/pointOfSale/mutationTypes';
import * as MutationTypes from './mutationTypes';

const menuRecommendationSuccess = (state, menuRecommendation) => {
  state.menuRecommendation = menuRecommendation;
};

const menuRecommendationListSuccess = (state, menuRecommendationList) => {
  state.menuRecommendationList = menuRecommendationList;
};

const setMenuEngineeringSectionConfirmed = (state, { sectionGuid, confirmed }) => {
  state.menuRecommendation
    .sections
    .find((section) => section.guid === sectionGuid).confirmed = confirmed;
};

const menuEngineeringModifySection = (state, { sectionGuid, demandObject }) => {
  const demandIndex = state.menuRecommendation
    .sections.find(((section) => section.guid === sectionGuid))
    .recommendations_by_demand.findIndex((demand) => demand.code_name === demandObject.code_name);

  state.menuRecommendation
    .sections.find(((section) => section.guid === sectionGuid))
    .recommendations_by_demand.splice(demandIndex, 1, demandObject);
};

const resetPointOfSaleData = (state) => {
  state.menuRecommendation = null;
  state.menuRecommendationList = [];
  state.periodEngineeringProfitability = null;
  state.isEngineeringProfitabilityLoading = false;
};

export const periodEngineeringProfitabilitySuccess = (state, periodEngineeringProfitability) => {
  state.periodEngineeringProfitability = periodEngineeringProfitability;
};

export const menuEngineeringProfitabilitySuccess = (state, { periodEngineeringProfitability, menuGuid }) => {
  state.periodEngineeringProfitability.updateMenuProfitability(periodEngineeringProfitability, menuGuid);
};

export const sectionEngineeringProfitabilitySuccess = (state, { periodEngineeringProfitability, menuGuid, sectionGuids }) => {
  state.periodEngineeringProfitability.updateSectionProfitabilities(periodEngineeringProfitability, menuGuid, sectionGuids);
};

export const setEngineeringProfitabilityLoading = (state, isLoading) => {
  state.isEngineeringProfitabilityLoading += isLoading;
};

export const validateMenuEngineeringRecommendation = (state, menuEngineeringRecommendationGuid) => {
  state.menuRecommendationList = state.menuRecommendationList.map((m) => {
    if (m.guid === menuEngineeringRecommendationGuid) m.isRecommendationValidated = true;
    return m;
  });
};

export const mutations = {
  [MutationTypes.MENU_RECOMMENDATION_SUCCESS]: menuRecommendationSuccess,
  [MutationTypes.MENU_RECOMMENDATION_LIST_SUCCESS]: menuRecommendationListSuccess,
  [MutationTypes.MENU_ENGINEERING_SECTION_SET_CONFIRMED]: setMenuEngineeringSectionConfirmed,
  [MutationTypes.MENU_ENGINEERING_MODIFY_SECTION]: menuEngineeringModifySection,
  [MutationTypes.PERIOD_ENGINEERING_PROFITABILITY_SUCCESS]: periodEngineeringProfitabilitySuccess,
  [MutationTypes.MENU_ENGINEERING_PROFITABILITY_SUCCESS]: menuEngineeringProfitabilitySuccess,
  [MutationTypes.SECTION_ENGINEERING_PROFITABILITY_SUCCESS]: sectionEngineeringProfitabilitySuccess,
  [MutationTypes.SET_ENGINEERING_PROFITABILITY_LOADING]: setEngineeringProfitabilityLoading,
  [MutationTypes.VALIDATE_MENU_ENGINEERING_RECOMMENDATION]: validateMenuEngineeringRecommendation,
  [RESET_POINT_OF_SALE_STATE]: resetPointOfSaleData
};
